module.exports = "https://coursera_assets.s3.amazonaws.com/images/68bb9c1034fc28228fa17c6008e48717.png";